var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/contentful/render-entry.j2"] = require( "macros/contentful/render-entry.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/size-guide/vendor-tab.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/contentful/render-entry.j2", false, "product/templates/size-guide/vendor-tab.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("renderEntry")) {
var t_4 = t_1.renderEntry;
} else {
cb(new Error("cannot import 'renderEntry'")); return;
}
context.setVariable("renderEntry", t_4);
var t_5;
t_5 = 0;
frame.set("selectedTabIndex", t_5, true);
if(frame.topLevel) {
context.setVariable("selectedTabIndex", t_5);
}
if(frame.topLevel) {
context.addExport("selectedTabIndex", t_5);
}
output += "\n";
var t_6;
t_6 = (runtime.contextOrFrameLookup(context, frame, "loop")?runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0"):0);
frame.set("index", t_6, true);
if(frame.topLevel) {
context.setVariable("index", t_6);
}
if(frame.topLevel) {
context.addExport("index", t_6);
}
output += "\n\n<div class=\"o-row o-column dom-size-guide-vendor-tab-component\">\n\n    <div class=\"o-column o-extra-large--12 js-tab-content-panel ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "jsClass"), env.opts.autoescape);
output += "\" data-tab-index=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "index"), env.opts.autoescape);
output += "\" data-qa-tab-panel>\n            ";
var t_7;
t_7 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"sizeGuide")),"modules")),runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"sizeGuide")),"vendorTab"));
frame.set("entry", t_7, true);
if(frame.topLevel) {
context.setVariable("entry", t_7);
}
if(frame.topLevel) {
context.addExport("entry", t_7);
}
output += "\n            ";
output += runtime.suppressValue((lineno = 9, colno = 24, runtime.callWrap(t_4, "renderEntry", context, [runtime.contextOrFrameLookup(context, frame, "entry")])), env.opts.autoescape);
output += "\n    </div>\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/size-guide/vendor-tab.j2"] , dependencies)